var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnInit } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { ReloadPageEntries } from '../../state/actions/commands';
import { DriveState } from '../../state/drive-state';
import { Observable } from 'rxjs';
import { FormControl } from '@angular/forms';
var FileListHeaderComponent = /** @class */ (function () {
    function FileListHeaderComponent(store) {
        this.store = store;
        this.sortFormControl = new FormControl({
            column: this.store.selectSnapshot(DriveState.sortColumn),
            direction: this.store.selectSnapshot(DriveState.sortDirection),
        });
    }
    FileListHeaderComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.activePage$.subscribe(function (activePage) {
            _this.sortFormControl.setValue({
                column: activePage.sortColumn,
                direction: activePage.sortDirection
            }, { emitEvent: false });
        });
        this.sortFormControl.valueChanges.subscribe(function (sort) {
            _this.store.dispatch(new ReloadPageEntries({ orderBy: sort.column, orderDir: sort.direction }));
        });
    };
    __decorate([
        Select(DriveState.sortColumn),
        __metadata("design:type", Observable)
    ], FileListHeaderComponent.prototype, "sortColumn$", void 0);
    __decorate([
        Select(DriveState.activePage),
        __metadata("design:type", Observable)
    ], FileListHeaderComponent.prototype, "activePage$", void 0);
    return FileListHeaderComponent;
}());
export { FileListHeaderComponent };
